import { gql, TypedDocumentNode } from '@apollo/client';

import {
  UpdateMyUserSettingsMutation,
  UpdateMyUserSettingsMutationVariables,
} from '../generated';

export const UPDATE_MY_USER_SETTINGS: TypedDocumentNode<
  UpdateMyUserSettingsMutation,
  UpdateMyUserSettingsMutationVariables
> = gql`
  mutation UpdateMyUserSettings($input: UpdateUserSettingsInput!) {
    updateMyUserSettings(input: $input) {
      id
      email
      settings {
        aiAssistEditChatModel
      }
      effectiveAiAssistEditChatModel
    }
  }
`;
